export function decodeJwt(token) {
    try {
        // JWT structure: header.payload.signature — extract the middle segment
        const tokenPayload = token.split('.')[1]
        // JWT uses base64url encoding; convert to standard base64 before decoding
        const base64 = tokenPayload.replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(atob(base64))
    } catch {
        return {}
    }
}
